export default [
  {
    name: 'dashboard',
    path: '/dashboard',
    meta: {
      title: '仪表盘',
      is_show: 1
    },
    component: () => import('@/views/dashboard/index.vue')
  }
]

export const homePage = {
  name: 'home',
  path: '/home',
  meta: { title: '首页', icon: 'menu-setting', is_show: 1 },
  children: []
}
